import React, { useEffect, useState, useMemo } from "react";
import { API, UPLOADS } from "../../config/api";

import "../Styles/addwork.css";
import WorkBidsModal from "./WorkBidsModal";
import DateFilter from "../../Admin/Pages/DateFilter";
const getPaymentAccessInfo = (item) => {
  if (!item?.delivered_date) {
    return {
      allowed: false,
      message: "Work is not delivered",
      remainingDays: 0,
    };
  }

  const deliveredDate = new Date(item.delivered_date);
  const today = new Date();

  deliveredDate.setHours(0, 0, 0, 0);
  today.setHours(0, 0, 0, 0);

  const diffDays = Math.floor((today - deliveredDate) / (1000 * 60 * 60 * 24));

  const remainingDays = 5 - diffDays;

  if (diffDays < 0) {
    return {
      allowed: false,
      message: "",
      remainingDays: 0,
    };
  }

  if (remainingDays > 0) {
    return {
      allowed: true,
      message: (
        <>
          You have <br />
          <b style={{ color: "#dd3e3e", fontSize: "13px" }}>
            {remainingDays} {remainingDays === 1 ? "day" : "days"}
          </b>{" "}
          to view work
        </>
      ),
      remainingDays,
    };
  }

  return {
    allowed: false,
    message: "Your 5-day access period has expired.",
    remainingDays: 0,
  };
};
export default function AddWork() {
  const BASE_URL = `${API.BASE_URL}/api.php`;
  const BASE_URL1 = `${API.BASE_URL}/payment.php`;
  const user = JSON.parse(sessionStorage.getItem("user")) || { id: 1 };

  const [description, setDescription] = useState("");
  const DESCRIPTION_OPTIONS = ["Multi", "Sequence", "Cording", "Beads"];

  const [selectedDescriptionOptions, setSelectedDescriptionOptions] = useState(
    [],
  );
  const [extraDescription, setExtraDescription] = useState("");
  const [existingImages, setExistingImages] = useState([]);
  const [newImages, setNewImages] = useState([]);
  const [newPreview, setNewPreview] = useState([]);
  const [workList, setWorkList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [showBidModal, setShowBidModal] = useState(false);
  const [selectedWork, setSelectedWork] = useState(null);
  const [showDescriptionModal, setShowDescriptionModal] = useState(false);
  const [selectedDescription, setSelectedDescription] = useState("");
  const [hoverPreview, setHoverPreview] = useState({
    workId: null,
    imageIndex: null,
    image: null,
  });
  const [showRatingModal, setShowRatingModal] = useState(false);
  const [ratingWork, setRatingWork] = useState(null);
  const [selectedRating, setSelectedRating] = useState(0);
  const [ratingLoading, setRatingLoading] = useState(false);
  const [newBidWorks, setNewBidWorks] = useState([]);
  const [newBidPopup, setNewBidPopup] = useState([]);
  const [height, setHeight] = useState("");
  const [area, setArea] = useState("");
  const [color, setColor] = useState("");
  // Modal State for Image Lightbox
  const [selectedImageModal, setSelectedImageModal] = useState(null);

  // Filter States
  const [statusFilter, setStatusFilter] = useState("ALL");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const STATUS_LIST = [
    "ALL",
    "Pending",
    "Active",
    "Accepted",
    "Start Work",
    "In Progress",
    "Work in Review",
    "Completed",
  ];

  useEffect(() => {
    fetchWorks();
  }, []);
  const openImageModal = (images, index, ownerId) => {
    const imageUrls = images.map(
      (img) => `${UPLOADS.WORK_IMAGE}/${ownerId}/${img}`,
    );

    setSelectedImageModal({
      images: imageUrls,
      currentIndex: index,
    });
  };

  const prevImage = () => {
    setSelectedImageModal((prev) => ({
      ...prev,
      currentIndex:
        prev.currentIndex === 0
          ? prev.images.length - 1
          : prev.currentIndex - 1,
    }));
  };

  const nextImage = () => {
    setSelectedImageModal((prev) => ({
      ...prev,
      currentIndex:
        prev.currentIndex === prev.images.length - 1
          ? 0
          : prev.currentIndex + 1,
    }));
  };
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (!selectedImageModal) return;

      if (e.key === "ArrowLeft") {
        prevImage();
      } else if (e.key === "ArrowRight") {
        nextImage();
      } else if (e.key === "Escape") {
        setSelectedImageModal(null);
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [selectedImageModal]);

  // Revoke object URLs on unmount/update to avoid memory leaks
  useEffect(() => {
    return () => {
      newPreview.forEach((url) => URL.revokeObjectURL(url));
    };
  }, [newPreview]);

  const fetchWorks = async (showNotification = true) => {
    try {
      const response = await fetch(
        `${BASE_URL}?action=get_my_works&owner_id=${user.id}`,
      );

      const result = await response.json();

      if (!result.status) return;

      const newWorks = result.data || [];

      const storageKey = `work_bid_counts_${user.id}`;

      const storedBidCounts = JSON.parse(
        localStorage.getItem(storageKey) || "{}",
      );

      const updatedBidCounts = {};
      const newlyUpdatedWorks = [];

      newWorks.forEach((work) => {
        const workId = String(work.id);
        const currentBids = Number(work.total_bids || 0);

        const previousBids = Number(storedBidCounts[workId] || 0);

        updatedBidCounts[workId] = currentBids;

        if (
          showNotification &&
          storedBidCounts[workId] !== undefined &&
          currentBids > previousBids
        ) {
          newlyUpdatedWorks.push({
            ...work,
            newBids: currentBids - previousBids,
          });
        }
      });

      /*
       * Don't show notification on first load.
       */
      const isFirstLoad = Object.keys(storedBidCounts).length === 0;

      if (!isFirstLoad && newlyUpdatedWorks.length > 0) {
        setNewBidWorks((prev) => {
          const existingIds = new Set(prev);

          newlyUpdatedWorks.forEach((work) => {
            existingIds.add(String(work.id));
          });

          return Array.from(existingIds);
        });

        /*
         * IMPORTANT:
         * Keep ALL newly updated works instead of
         * replacing popup with the last work.
         */
        setNewBidPopup(newlyUpdatedWorks);
      }

      localStorage.setItem(storageKey, JSON.stringify(updatedBidCounts));

      setWorkList(newWorks);
    } catch (error) {
      console.error(error);
    }
  };
  const getDisplayStatus = (status) => {
    return String(status || "")
      .trim()
      .toLowerCase() === "paid"
      ? "Completed"
      : status || "Pending";
  };
  useEffect(() => {
    // Check every 30 seconds
    const interval = setInterval(() => {
      fetchWorks(true);
    }, 30000);

    return () => clearInterval(interval);
  }, []);
  // Status counts calculation
  const statusCounts = useMemo(() => {
    const counts = { ALL: workList.length };
    STATUS_LIST.forEach((st) => {
      if (st !== "ALL") counts[st] = 0;
    });

    workList.forEach((item) => {
      const rawStatus = getDisplayStatus(item.status).trim().toLowerCase();
      STATUS_LIST.forEach((st) => {
        if (st !== "ALL" && st.toLowerCase() === rawStatus) {
          counts[st] = (counts[st] || 0) + 1;
        }
      });
    });

    return counts;
  }, [workList]);
  const DESIGN_TYPES = ["Multi", "Sequence", "Cording", "Beads"];
  const getWorkDescriptionData = (description = "") => {
    if (!description) {
      return {
        designTypes: "",
        extraDescription: "",
      };
    }

    // Split description by comma or new line
    const parts = description
      .split(/,|\n/)
      .map((item) => item.trim())
      .filter(Boolean);

    const selectedTypes = [];
    const extraParts = [];

    parts.forEach((part) => {
      const matchedType = DESIGN_TYPES.find(
        (type) => type.toLowerCase() === part.toLowerCase(),
      );

      if (matchedType) {
        selectedTypes.push(matchedType);
      } else {
        extraParts.push(part);
      }
    });

    return {
      designTypes: selectedTypes.join(", "),
      extraDescription: extraParts.join(", "),
    };
  };
  const openDescriptionModal = (work) => {
    const { designTypes, extraDescription } = getWorkDescriptionData(
      work.description || "",
    );

    setSelectedDescription({
      description: extraDescription || "",
      height: work.height || "-",
      area: work.area || "-",
      color: work.color || "-",
      designType: designTypes || "-",
    });

    setShowDescriptionModal(true);
  };
  // Filter logic for Status & Date Range
  const filteredWorkList = useMemo(() => {
    return workList.filter((item) => {
      // 1. Status Filter
      if (statusFilter !== "ALL") {
        const itemStatus = getDisplayStatus(item.status).toLowerCase().trim();

        if (itemStatus !== statusFilter.toLowerCase().trim()) {
          return false;
        }
      }

      // 2. Date Filter
      if (item.created_at) {
        const itemDate = new Date(item.created_at);
        itemDate.setHours(0, 0, 0, 0);

        if (startDate) {
          const start = new Date(startDate);
          start.setHours(0, 0, 0, 0);
          if (itemDate < start) return false;
        }

        if (endDate) {
          const end = new Date(endDate);
          end.setHours(23, 59, 59, 999);
          if (itemDate > end) return false;
        }
      }

      return true;
    });
  }, [workList, statusFilter, startDate, endDate]);

  const resetFilters = () => {
    setStatusFilter("ALL");
    setStartDate("");
    setEndDate("");
  };

  const downloadWork = async (workId) => {
    try {
      const response = await fetch(
        `${BASE_URL1}?action=get_work_delivery&work_id=${workId}`,
      );
      const result = await response.json();

      if (!result.status) {
        alert(result.message);
        return;
      }

      const files = result.data.design_files || [];
      if (files.length === 0) {
        alert("No files uploaded.");
        return;
      }

      files.forEach((file) => {
        window.open(
          `${API.BASE_URL}/download_work_file.php?work_id=${workId}&file=${encodeURIComponent(
            file,
          )}`,
          "_blank",
        );
      });
    } catch (err) {
      console.log(err);
    }
  };

  const completeWork = async (work) => {
    if (!window.confirm("Are you sure this work is completed?")) return;

    // Open rating modal first
    setRatingWork(work);
    setSelectedRating(0);
    setShowRatingModal(true);
  };
  const submitRating = async () => {
    if (!selectedRating) {
      alert("Please select a rating.");
      return;
    }

    if (!ratingWork?.id) {
      alert("Invalid work.");
      return;
    }

    setRatingLoading(true);

    try {
      const response = await fetch(
        `${BASE_URL1}?action=complete_work_with_rating`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            work_id: ratingWork.id,
            rating: selectedRating,
          }),
        },
      );

      const result = await response.json();

      alert(result.message);

      if (result.status || result.success) {
        setShowRatingModal(false);
        setRatingWork(null);
        setSelectedRating(0);

        fetchWorks();
      }
    } catch (error) {
      console.error(error);
      alert("Something went wrong while submitting the rating.");
    } finally {
      setRatingLoading(false);
    }
  };

  const handleImageChange = (e) => {
    const files = Array.from(e.target.files);

    if (!files.length) return;

    const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5 MB

    const validFiles = [];
    const rejectedFiles = [];

    files.forEach((file) => {
      if (file.size > MAX_FILE_SIZE) {
        rejectedFiles.push(file.name);
      } else {
        validFiles.push(file);
      }
    });

    // Show message for large files
    if (rejectedFiles.length > 0) {
      alert(
        `The following file(s) are larger than 5 MB and cannot be uploaded:\n\n${rejectedFiles.join(
          "\n",
        )}`,
      );
    }

    // Add only valid files
    if (validFiles.length > 0) {
      setNewImages((prev) => [...prev, ...validFiles]);

      const newObjectUrls = validFiles.map((file) => URL.createObjectURL(file));

      setNewPreview((prev) => [...prev, ...newObjectUrls]);
    }

    // Reset input so same file can be selected again
    e.target.value = "";
  };

  const removeNewImage = (index) => {
    URL.revokeObjectURL(newPreview[index]);
    setNewImages((prev) => prev.filter((_, i) => i !== index));
    setNewPreview((prev) => prev.filter((_, i) => i !== index));
  };

  const removeExistingImage = (index) => {
    setExistingImages((prev) => prev.filter((_, i) => i !== index));
  };
  const buildDescription = (options, extraText) => {
    const optionText = options.length > 0 ? options.join(", ") : "";

    const cleanExtra = extraText.trim();

    if (optionText && cleanExtra) {
      return `${optionText}\n${cleanExtra}`;
    }

    return optionText || cleanExtra;
  };

  const handleDescriptionOptionChange = (option) => {
    setSelectedDescriptionOptions((prev) => {
      const updated = prev.includes(option)
        ? prev.filter((item) => item !== option)
        : [...prev, option];

      // Update main description state
      setDescription(buildDescription(updated, extraDescription));

      return updated;
    });
  };
  const handleDownloadWork = async (item) => {
    const access = getPaymentAccessInfo(item);

    if (!access.allowed) {
      alert(access.message);
      return;
    }

    await downloadWork(item.id);
  };
  const handleExtraDescriptionChange = (value) => {
    setExtraDescription(value);

    // Update main description state
    setDescription(buildDescription(selectedDescriptionOptions, value));
  };
  const resetForm = () => {
    setDescription("");
    setSelectedDescriptionOptions([]);
    setExtraDescription("");

    setHeight("");
    setArea("");
    setColor("");
    setExistingImages([]);
    setNewImages([]);
    setNewPreview([]);
    setEditingId(null);

    const fileInput = document.getElementById("ebAwpImages");

    if (fileInput) fileInput.value = "";
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!description.trim()) {
      alert("Please enter a description");
      return;
    }

    if (!editingId && newImages.length === 0) {
      alert("Please select at least one image");
      return;
    }

    setLoading(true);
    const formData = new FormData();
    formData.append("owner_id", user.id);
    formData.append("description", description);

    if (height !== "") {
      formData.append("height", height);
    }

    if (area !== "") {
      formData.append("area", area);
    }

    if (color !== "") {
      formData.append("color", color);
    }
    newImages.forEach((img) => {
      formData.append("images[]", img);
    });

    let url = "";
    if (editingId) {
      url = `${BASE_URL}?action=update_work`;
      formData.append("id", editingId);
      formData.append("existing_images", JSON.stringify(existingImages));
    } else {
      url = `${BASE_URL}?action=add_work`;
    }

    try {
      const response = await fetch(url, {
        method: "POST",
        body: formData,
      });
      const result = await response.json();
      alert(result.message);

      if (result.status) {
        resetForm();
        fetchWorks();
      }
    } catch (error) {
      console.error(error);
    }
    setLoading(false);
  };

  const editWork = (item) => {
    setEditingId(item.id);

    const savedDescription = item.description || "";

    // Find selected checkbox options
    const selectedOptions = DESCRIPTION_OPTIONS.filter((option) => {
      const regex = new RegExp(`(^|,|\\n)\\s*${option}\\s*(?=,|\\n|$)`, "i");

      return regex.test(savedDescription);
    });

    // Remove checkbox values from extra description
    let remainingDescription = savedDescription;

    selectedOptions.forEach((option) => {
      const regex = new RegExp(`(^|,|\\n)\\s*${option}\\s*(?=,|\\n|$)`, "gi");

      remainingDescription = remainingDescription.replace(regex, "$1");
    });

    // Clean extra commas and blank lines
    remainingDescription = remainingDescription
      .replace(/,\s*,/g, ",")
      .replace(/^\s*,\s*/g, "")
      .replace(/\s*,\s*$/g, "")
      .replace(/^\s*\n/gm, "")
      .trim();

    setSelectedDescriptionOptions(selectedOptions);
    setExtraDescription(remainingDescription);

    // Keep final description
    setDescription(buildDescription(selectedOptions, remainingDescription));

    setHeight(item.height || "");
    setArea(item.area || "");
    setColor(item.color || "");

    setExistingImages(item.images || []);
    setNewImages([]);
    setNewPreview([]);

    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const deleteWork = async (id) => {
    if (!window.confirm("Are you sure you want to delete this work?")) return;

    const formData = new FormData();
    formData.append("id", id);
    formData.append("owner_id", user.id);

    try {
      const response = await fetch(`${BASE_URL}?action=delete_work`, {
        method: "POST",
        body: formData,
      });
      const result = await response.json();
      alert(result.message);

      if (result.status) {
        fetchWorks();
      }
    } catch (error) {
      console.error(error);
    }
  };

  const openBids = (work) => {
    setSelectedWork(work);
    setShowBidModal(true);
  };

  const getStatusClass = (status) => {
    const displayStatus = getDisplayStatus(status);
    const st = displayStatus.toLowerCase().trim();

    switch (st) {
      case "pending":
        return "eb-awp-badge-pending";

      case "active":
        return "eb-awp-badge-active";

      case "accepted":
        return "eb-awp-badge-accepted";

      case "start work":
        return "eb-awp-badge-start";

      case "in progress":
        return "eb-awp-badge-progress";

      case "work in review":
        return "eb-awp-badge-review";

      case "completed":
        return "eb-awp-badge-completed";

      default:
        return "eb-awp-badge-default";
    }
  };
  const handleImageHover = (e, item, index, imgSrc) => {
    const rect = e.currentTarget.getBoundingClientRect();

    const previewWidth = 310;
    const previewHeight = 310;
    const gap = 12;

    // Default: preview on right side
    let left = rect.right + gap;
    let top = rect.top;

    // If no space on right, show on left
    if (left + previewWidth > window.innerWidth - 10) {
      left = rect.left - previewWidth - gap;
    }

    // If no space below, move preview upward
    if (top + previewHeight > window.innerHeight - 10) {
      top = window.innerHeight - previewHeight - 10;
    }

    // Prevent preview going above screen
    if (top < 10) {
      top = 10;
    }

    setHoverPreview({
      workId: item.id,
      imageIndex: index,
      image: imgSrc,
      left,
      top,
    });
  };
  const getDesignTypes = (description = "") => {
    const lines = description
      .split(/\n/)
      .map((line) => line.trim())
      .filter(Boolean);

    const selectedTypes = [];

    lines.forEach((line) => {
      line.split(",").forEach((value) => {
        const cleanValue = value.trim();

        const matchedOption = DESCRIPTION_OPTIONS.find(
          (option) => option.toLowerCase() === cleanValue.toLowerCase(),
        );

        if (matchedOption && !selectedTypes.includes(matchedOption)) {
          selectedTypes.push(matchedOption);
        }
      });
    });

    return selectedTypes;
  };

  const getExtraDescription = (description = "") => {
    const selectedTypes = getDesignTypes(description);

    let extraText = description;

    selectedTypes.forEach((type) => {
      const regex = new RegExp(`(^|,|\\n)\\s*${type}\\s*(?=,|\\n|$)`, "gi");

      extraText = extraText.replace(regex, "$1");
    });

    return extraText
      .replace(/,\s*,/g, ",")
      .replace(/^\s*,\s*/g, "")
      .replace(/\s*,\s*$/g, "")
      .replace(/^\s*\n/gm, "")
      .replace(/\n\s*\n+/g, "\n")
      .trim();
  };
  return (
    <div className="eb-awp-wrapper">
      {/* Header */}
      {/* Header */}
      <div className="eb-awp-page-header">
        <div>
          <h2 className="eb-awp-title">Work Management</h2>

          <p className="eb-awp-subtitle">
            Upload embroidery specifications, monitor order progress, and
            process bids.
          </p>
        </div>
      </div>

      {/* Main Form Section */}
      <section className="eb-awp-card">
        <div className="eb-awp-card-header">
          <div className="eb-awp-card-title">
            <i className="bi bi-cloud-plus-fill eb-awp-icon-accent"></i>
            <h3>{editingId ? "Edit Work Details" : "Add Work Details"}</h3>
          </div>
          <div className="eb-awp-header-note">
            <i className="bi bi-info-circle-fill"></i>

            <div>
              <strong>
                {/* You can upload multiple images, but all images must belong to
                the same design.  */}
                {/* Do not upload images of different designs in one work request. */}
                Upload Images Only for One Design
              </strong>
            </div>
          </div>
          {editingId && (
            <button
              type="button"
              className="eb-awp-btn-cancel"
              onClick={resetForm}
            >
              <i className="bi bi-x-circle me-1"></i> Cancel Editing
            </button>
          )}
        </div>

        <form onSubmit={handleSubmit} className="eb-awp-card-body">
          <div className="eb-awp-grid">
            {/* Dropzone */}
            <div className="eb-awp-field">
              <label className="eb-awp-label">Design Images</label>
              <div className="eb-awp-dropzone">
                <input
                  id="ebAwpImages"
                  type="file"
                  multiple
                  accept="image/*"
                  className="eb-awp-file-input"
                  onChange={handleImageChange}
                />
                <label
                  htmlFor="ebAwpImages"
                  className="eb-awp-dropzone-content"
                >
                  <div className="eb-awp-drop-icon-wrapper">
                    <i className="bi bi-cloud-arrow-up-fill"></i>
                  </div>
                  <span className="eb-awp-dropzone-primary">
                    Click to browse or drop images
                  </span>
                  <span className="eb-awp-dropzone-secondary">
                    Supports PNG, JPG, JPEG files
                  </span>
                </label>
              </div>
            </div>

            {/* Description */}
            {/* Description */}
            <div className="eb-awp-field">
              <label className="eb-awp-label">
                Work Description & Requirements
              </label>

              {/* CHECKBOX OPTIONS */}
              <div className="eb-awp-description-options">
                {DESCRIPTION_OPTIONS.map((option) => (
                  <label
                    key={option}
                    className={`eb-awp-description-check ${
                      selectedDescriptionOptions.includes(option)
                        ? "active"
                        : ""
                    }`}
                  >
                    <input
                      type="checkbox"
                      checked={selectedDescriptionOptions.includes(option)}
                      onChange={() => handleDescriptionOptionChange(option)}
                    />

                    <span className="eb-awp-custom-check">
                      <i className="bi bi-check-lg"></i>
                    </span>

                    <span>{option}</span>
                  </label>
                ))}
              </div>

              {/* EXTRA DESCRIPTION */}
              <textarea
                className="eb-awp-textarea eb-awp-extra-description"
                rows="3"
                placeholder="Add other requirements or extra information here..."
                value={extraDescription}
                onChange={(e) => handleExtraDescriptionChange(e.target.value)}
              />

              {/* OPTIONAL PREVIEW */}
              {/* {description && (
                <div className="eb-awp-description-preview">
                  <strong>Final Description:</strong>

                  <p>{description}</p>
                </div>
              )} */}
            </div>
          </div>

          {/* Media Previews */}
          {(existingImages.length > 0 || newPreview.length > 0) && (
            <div className="eb-awp-media-section">
              <span className="eb-awp-media-title">
                Attached Media Files (
                {existingImages.length + newPreview.length})
              </span>
              <div className="eb-awp-media-grid">
                {existingImages.map((img, index) => (
                  <div className="eb-awp-media-tile" key={`old-${index}`}>
                    <img
                      src={`${UPLOADS.WORK_IMAGE}/${user.id}/${img}`}
                      alt="Existing artwork"
                    />
                    <button
                      type="button"
                      className="eb-awp-tile-remove"
                      onClick={() => removeExistingImage(index)}
                      title="Remove image"
                    >
                      &times;
                    </button>
                    <span className="eb-awp-tile-badge eb-awp-badge-saved">
                      Saved
                    </span>
                  </div>
                ))}

                {newPreview.map((img, index) => (
                  <div className="eb-awp-media-tile" key={`new-${index}`}>
                    <img src={img} alt="New upload" />
                    <button
                      type="button"
                      className="eb-awp-tile-remove"
                      onClick={() => removeNewImage(index)}
                      title="Remove image"
                    >
                      &times;
                    </button>
                    <span className="eb-awp-tile-badge eb-awp-badge-new">
                      New
                    </span>
                  </div>
                ))}
              </div>
            </div>
          )}
          <div className="eb-awp-grid1">
            <div className="eb-awp-field">
              <label className="eb-awp-label">Height (MM)</label>
              <input
                type="number"
                className="eb-awp-input"
                placeholder="Enter Height"
                value={height}
                onChange={(e) => setHeight(e.target.value)}
              />
            </div>

            <div className="eb-awp-field">
              <label className="eb-awp-label">Area (MM)</label>
              <input
                type="number"
                className="eb-awp-input"
                placeholder="Enter Area"
                value={area}
                onChange={(e) => setArea(e.target.value)}
              />
            </div>

            <div className="eb-awp-field">
              <label className="eb-awp-label">Color</label>
              <input
                type="text"
                className="eb-awp-input"
                placeholder="Enter Color"
                value={color}
                onChange={(e) => setColor(e.target.value)}
              />
            </div>
          </div>

          <div className="eb-awp-form-actions">
            <button
              type="submit"
              className="eb-awp-btn-submit"
              disabled={loading}
            >
              {loading ? (
                <>
                  <span className="eb-awp-spinner"></span> Submitting...
                </>
              ) : editingId ? (
                <>
                  <i className="bi bi-check-lg me-1"></i> Update Requirement
                </>
              ) : (
                <>
                  <i className="bi bi-plus-lg me-1"></i> Post Work
                </>
              )}
            </button>
          </div>
        </form>
      </section>

      {/* Table & Filtering Section */}
      <section className="eb-awp-card">
        <div className="eb-awp-card-header eb-awp-header-flex">
          <div className="eb-awp-title-badge-group">
            <h3 className="eb-awp-table-heading">My Posted Works</h3>
            <span className="eb-awp-count-tag">
              Showing {filteredWorkList.length} of {workList.length}
            </span>
          </div>
          <span
            style={{ fontSize: "14px", fontWeight: "bold", color: "#b41f1f" }}
          >
            Admin Contact No: +91 9909614445
          </span>
          {/* Integrated Date Filter Component */}
          <div className="eb-awp-filter-actions">
            <DateFilter
              fromDate={startDate}
              toDate={endDate}
              setFromDate={setStartDate}
              setToDate={setEndDate}
            />

            {(statusFilter !== "ALL" || startDate || endDate) && (
              <button
                type="button"
                className="eb-awp-btn-reset"
                onClick={resetFilters}
                title="Reset all filters"
              >
                <i className="bi bi-arrow-counterclockwise"></i> Reset
              </button>
            )}
          </div>
        </div>

        {/* Sequential Status Sequence Bar */}
        <div className="eb-awp-status-bar">
          {STATUS_LIST.map((st) => {
            const isActive = statusFilter === st;
            const count = statusCounts[st] || 0;

            return (
              <button
                key={st}
                type="button"
                className={`eb-awp-status-tab ${isActive ? "active" : ""}`}
                onClick={() => setStatusFilter(st)}
              >
                <span>{st}</span>
                <span className="eb-awp-tab-count">{count}</span>
              </button>
            );
          })}
        </div>

        {/* Data Table */}
        <div className="eb-awp-table-responsive">
          <table className="eb-awp-table">
            <thead>
              <tr>
                <th style={{ width: "45px" }}>#</th>
                <th style={{ width: "110px" }}>Posted Date</th>
                <th style={{ width: "110px" }}>Image</th>
                {/* <th>Details</th>
                <th>Design Type</th> */}
                <th>Description</th>
                <th style={{ width: "120px" }}>Accepted Price</th>
                <th style={{ width: "130px" }}>Submitted Date</th>
                <th style={{ width: "130px" }}>Status</th>
                <th>Rating</th>
                <th style={{ textAlign: "right", width: "280px" }}>Actions</th>
              </tr>
            </thead>
            <tbody>
              {filteredWorkList.length ? (
                filteredWorkList.map((item, index) => (
                  <tr key={item.id}>
                    <td className="eb-awp-col-index">
                      {filteredWorkList.length - index}
                    </td>
                    <td className="eb-awp-col-date">
                      <i className="bi bi-calendar-event me-1"></i>
                      {new Date(item.created_at).toLocaleDateString("en-GB", {
                        day: "2-digit",
                        month: "short",
                        year: "numeric",
                      })}
                    </td>
                    <td>
                      <div className="eb-awp-thumb-group">
                        {item.images?.map((img, i) => {
                          const imgSrc = `${UPLOADS.WORK_IMAGE}/${item.owner_id}/${img}`;

                          return (
                            <div
                              key={i}
                              className="eb-awp-thumb-box"
                              onMouseEnter={(e) =>
                                handleImageHover(e, item, i, imgSrc)
                              }
                              onMouseLeave={() =>
                                setHoverPreview({
                                  workId: null,
                                  imageIndex: null,
                                  image: null,
                                  left: 0,
                                  top: 0,
                                })
                              }
                              onClick={() =>
                                openImageModal(item.images, i, item.owner_id)
                              }
                            >
                              <img src={imgSrc} alt={`Work ${i + 1}`} />
                            </div>
                          );
                        })}
                      </div>
                    </td>
                    {/* <td>
                      <div>
                        <small>
                          <strong>H:</strong> {item.height || ""}
                        </small>
                        <br />
                        <small>
                          <strong>Area:</strong> {item.area || ""}
                        </small>
                        <br />
                        <small>
                          <strong>Color:</strong> {item.color || ""}
                        </small>
                      </div>
                    </td>
                    <td>
                      {getDesignTypes(item.description).length > 0 ? (
                        <span className="eb-awp-design-type">
                          {getDesignTypes(item.description).join(", ")}
                        </span>
                      ) : (
                        <span className="eb-awp-text-muted">-</span>
                      )}
                    </td> */}

                    <td>
                      {(() => {
                        const { extraDescription } = getWorkDescriptionData(
                          item.description || "",
                        );

                        return (
                          <p
                            className="vwk-table-desc-text"
                            style={{
                              cursor: "pointer",
                              marginBottom: 0,
                            }}
                            onClick={(e) => {
                              e.stopPropagation();
                              openDescriptionModal(item);
                            }}
                            title="Click to view full description"
                          >
                            {extraDescription?.length > 120
                              ? `${extraDescription.substring(0, 120)}...`
                              : extraDescription || "-"}
                          </p>
                        );
                      })()}
                    </td>
                    <td className="eb-awp-col-price">
                      {item.accepted_price ? (
                        <span className="eb-awp-price-tag">
                          ₹{item.accepted_price}
                        </span>
                      ) : (
                        <span className="eb-awp-text-muted">-</span>
                      )}
                    </td>
                    <td className="eb-awp-col-delivery">
                      {item.delivered_date ? (
                        <>
                          <span className="eb-awp-deliv-date">
                            {new Date(item.delivered_date).toLocaleDateString(
                              "en-GB",
                              {
                                day: "2-digit",
                                month: "short",
                                year: "numeric",
                              },
                            )}
                          </span>
                          <span className="eb-awp-deliv-time">
                            {new Date(item.delivered_date).toLocaleTimeString(
                              "en-GB",
                              {
                                hour: "2-digit",
                                minute: "2-digit",
                              },
                            )}
                          </span>
                        </>
                      ) : (
                        <span className="eb-awp-text-muted">-</span>
                      )}
                    </td>
                    <td>
                      {/* <span
                        className={`eb-awp-badge ${getStatusClass(
                          item.status,
                        )}`}
                      >
                        {item.status || "Pending"}
                      </span> */}
                      <span
                        className={`eb-awp-badge ${getStatusClass(item.status)}`}
                      >
                        {getDisplayStatus(item.status)}
                      </span>{" "}
                      <br />
                      {item.status === "Pending" && (
                        <>
                          <span style={{ fontSize: "11px", fontWeight: "600" }}>
                            Request In Review
                          </span>
                        </>
                      )}
                    </td>
                    <td>
                      {item.rating && Number(item.rating) > 0 ? (
                        <div className="eb-awp-work-rating">
                          {[1, 2, 3, 4, 5].map((star) => (
                            <i
                              key={star}
                              className={
                                star <= Number(item.rating)
                                  ? "bi bi-star-fill"
                                  : "bi bi-star"
                              }
                            ></i>
                          ))}

                          <span>{Number(item.rating).toFixed(1)}</span>
                        </div>
                      ) : (
                        <span className="eb-awp-text-muted">Not Rated</span>
                      )}
                    </td>
                    <td style={{ textAlign: "right" }}>
                      <div className="eb-awp-action-row">
                        {/* View Bids Button */}
                        <button
                          className={`eb-awp-act-btn eb-awp-act-bids
    ${
      String(item.status).toLowerCase() === "active" &&
      Number(item.total_bids) > 0
        ? "eb-awp-has-bids eb-awp-new-bid-highlight"
        : ""
    }
  `}
                          title={`View ${item.total_bids || 0} Applied Bidders`}
                          onClick={() => {
                            openBids(item);

                            // Remove highlight after viewing
                            setNewBidWorks((prev) =>
                              prev.filter((id) => id !== String(item.id)),
                            );
                          }}
                        >
                          <i className="bi bi-people-fill"></i>(
                          {item.total_bids || 0})
                          {/* {newBidWorks.includes(String(item.id)) && (
                            <span className="eb-awp-new-label">NEW</span>
                          )} */}
                        </button>

                        {/* Download Delivery Button */}
                        {/* Download Delivery Button */}
                        {(item.status === "Work in Review" ||
                          item.status === "Completed") && (
                          <>
                            <button
                              className="eb-awp-act-btn eb-awp-act-download"
                              title="Download Work Files"
                              onClick={() => handleDownloadWork(item)}
                            >
                              <i className="bi bi-download"></i>
                            </button>
                          </>
                        )}
                        {/* Complete Work Approval */}
                        {item.status === "Work in Review" && (
                          <>
                            <button
                              className="eb-awp-act-btn eb-awp-act-approve"
                              title="Approve & Complete"
                              onClick={() => completeWork(item)}
                            >
                              <i className="bi bi-check-circle-fill"></i>
                            </button>
                            <div className="eb-awp-payment-notice">
                              <span>{getPaymentAccessInfo(item).message}</span>
                            </div>
                          </>
                        )}

                        {/* Edit & Delete for Pending/Active */}
                        {(item.status === "Pending" ||
                          item.status === "Active" ||
                          !item.status) && (
                          <>
                            <button
                              className="eb-awp-act-btn eb-awp-act-edit"
                              title="Edit Work"
                              onClick={() => editWork(item)}
                            >
                              <i className="bi bi-pencil-square"></i>
                            </button>

                            <button
                              className="eb-awp-act-btn eb-awp-act-delete"
                              title="Delete Work"
                              onClick={() => deleteWork(item.id)}
                            >
                              <i className="bi bi-trash3-fill"></i>
                            </button>
                          </>
                        )}
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="9" className="eb-awp-empty-state">
                    <div className="eb-awp-empty-inner">
                      <i className="bi bi-inbox-fill"></i>
                      <p>
                        {workList.length === 0
                          ? "No works uploaded yet. Use the form above to post your first work entry."
                          : "No records found matching the chosen status or date filter."}
                      </p>
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </section>
      {newBidPopup.length > 0 && (
        <div>
          {/* <div className="eb-awp-new-bid-popup eb-awp-new-bid-popup-large">
            <button
              className="eb-awp-new-bid-popup-close"
              onClick={() => setNewBidPopup([])}
            >
              &times;
            </button>

           
            <div className="eb-awp-new-bid-popup-icon">
              <i className="bi bi-bell-fill"></i>
            </div>

            <h4>New Bids Received!</h4>

            <p>New bidders have applied to your work.</p>

          
            <div className="eb-awp-new-bid-work-list">
              {newBidPopup.map((work) => (
                <div key={work.id} className="eb-awp-new-bid-work-card">
                
                  <div className="eb-awp-new-bid-work-image">
                    {work.images?.length > 0 ? (
                      <img
                        src={`${UPLOADS.WORK_IMAGE}/${work.owner_id}/${work.images[0]}`}
                        alt="Work"
                      />
                    ) : (
                      <div className="eb-awp-no-work-image">
                        <i className="bi bi-image"></i>
                      </div>
                    )}
                  </div>

               
                  <div className="eb-awp-new-bid-work-content">
                    <div className="eb-awp-new-bid-work-title">
                      Work #{work.id}
                    </div>

                    <p className="eb-awp-new-bid-work-description">
                      {work.description || "No description available"}
                    </p>

                    <div className="eb-awp-new-bid-work-meta">
                      <span className="eb-awp-new-bid-new-count">
                        <i className="bi bi-person-plus-fill"></i>
                        {work.newBids} New
                      </span>

                      <span className="eb-awp-new-bid-total-count">
                        <i className="bi bi-people-fill"></i>
                        {work.total_bids} Total
                      </span>
                    </div>

                    <button
                      className="eb-awp-new-bid-view-btn"
                      onClick={() => {
                        openBids(work);

                        setNewBidWorks((prev) =>
                          prev.filter((id) => id !== String(work.id)),
                        );

                        setNewBidPopup((prev) =>
                          prev.filter(
                            (item) => String(item.id) !== String(work.id),
                          ),
                        );
                      }}
                    >
                      <i className="bi bi-people-fill me-2"></i>
                      View Bidders
                    </button>
                  </div>
                </div>
              ))}
            </div>

          
            <button
              className="eb-awp-new-bid-popup-btn"
              onClick={() => setNewBidPopup([])}
            >
              <i className="bi bi-check2"></i>
              Got It
            </button>
          </div> */}
        </div>
      )}
      {/* Global Hover Image Preview */}
      {hoverPreview.image && (
        <div
          className="eb-awp-hover-preview"
          style={{
            left: `${hoverPreview.left}px`,
            top: `${hoverPreview.top}px`,
          }}
        >
          <img src={hoverPreview.image} alt="Large preview" />
        </div>
      )}
      {/* Image Lightbox Modal */}
      {selectedImageModal && (
        <div
          className="eb-awp-modal-backdrop"
          onClick={() => setSelectedImageModal(null)}
        >
          <div
            className="eb-awp-modal-box"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              className="eb-awp-modal-close"
              onClick={() => setSelectedImageModal(null)}
            >
              &times;
            </button>
            <img
              src={selectedImageModal.images[selectedImageModal.currentIndex]}
              alt="Expanded view"
              className="eb-awp-modal-img"
            />

            {selectedImageModal.images.length > 1 && (
              <>
                <button
                  className="eb-awp-modal-arrow eb-awp-modal-prev"
                  onClick={prevImage}
                >
                  <i className="bi bi-chevron-left"></i>
                </button>

                <button
                  className="eb-awp-modal-arrow eb-awp-modal-next"
                  onClick={nextImage}
                >
                  <i className="bi bi-chevron-right"></i>
                </button>

                <div className="eb-awp-modal-counter">
                  {selectedImageModal.currentIndex + 1} /
                  {selectedImageModal.images.length}
                </div>
              </>
            )}
          </div>
        </div>
      )}

      <WorkBidsModal
        show={showBidModal}
        work={selectedWork}
        user={user}
        onClose={() => setShowBidModal(false)}
        onAccepted={() => {
          fetchWorks();
        }}
      />
      {showRatingModal && (
        <div
          className="eb-awp-rating-overlay"
          onClick={() => {
            if (!ratingLoading) {
              setShowRatingModal(false);
              setRatingWork(null);
              setSelectedRating(0);
            }
          }}
        >
          <div
            className="eb-awp-rating-modal"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              type="button"
              className="eb-awp-rating-close"
              disabled={ratingLoading}
              onClick={() => {
                setShowRatingModal(false);
                setRatingWork(null);
                setSelectedRating(0);
              }}
            >
              &times;
            </button>

            <div className="eb-awp-rating-icon">
              <i className="bi bi-star-fill"></i>
            </div>

            <h3>Rate Designer</h3>

            <p>Please rate the designer's work before completing this order.</p>

            <div className="eb-awp-rating-stars">
              {[1, 2, 3, 4, 5].map((star) => (
                <button
                  key={star}
                  type="button"
                  className={`eb-awp-rating-star ${
                    star <= selectedRating ? "selected" : ""
                  }`}
                  onClick={() => setSelectedRating(star)}
                  disabled={ratingLoading}
                >
                  <i className="bi bi-star-fill"></i>
                </button>
              ))}
            </div>

            <div className="eb-awp-rating-value">
              {selectedRating > 0
                ? `${selectedRating} / 5`
                : "Select your rating"}
            </div>

            <div className="eb-awp-rating-actions">
              <button
                type="button"
                className="eb-awp-rating-cancel"
                disabled={ratingLoading}
                onClick={() => {
                  setShowRatingModal(false);
                  setRatingWork(null);
                  setSelectedRating(0);
                }}
              >
                Cancel
              </button>

              <button
                type="button"
                className="eb-awp-rating-submit"
                disabled={!selectedRating || ratingLoading}
                onClick={submitRating}
              >
                {ratingLoading ? (
                  <>
                    <span className="eb-awp-spinner"></span>
                    Saving...
                  </>
                ) : (
                  <>
                    <i className="bi bi-check-circle-fill me-1"></i>
                    Submit Rating & Complete
                  </>
                )}
              </button>
            </div>
          </div>
        </div>
      )}
      {showDescriptionModal && (
        <div
          className="vwk-pm-overlay"
          onClick={() => setShowDescriptionModal(false)}
        >
          <div
            className="vwk-pm-modal vwk-description-modal"
            onClick={(e) => e.stopPropagation()}
          >
            {/* HEADER */}
            <div className="vwk-pm-header">
              <h4>
                <i className="bi bi-info-circle me-2"></i>
                Work Details
              </h4>

              <button
                className="vwk-pm-close-btn"
                onClick={() => setShowDescriptionModal(false)}
              >
                &times;
              </button>
            </div>

            {/* BODY */}
            <div className="vwk-pm-body">
              <div className="eb-work-description-section">
                <div className="eb-design-type-list">
                  {selectedDescription.designType &&
                  selectedDescription.designType !== "-" ? (
                    selectedDescription.designType
                      .split(",")
                      .map((type) => type.trim())
                      .filter(Boolean)
                      .map((type) => (
                        <span
                          key={type}
                          className={`eb-design-type-badge eb-design-type-${type
                            .toLowerCase()
                            .replace(/\s/g, "")}`}
                        >
                          <i className="bi bi-check-circle-fill"></i>
                          {type}
                        </span>
                      ))
                  ) : (
                    <p className="eb-info-desc">No design type selected.</p>
                  )}
                </div>
              </div>
              {/* HEIGHT / AREA / COLOR */}
              <div className="vwk-description-info-row">
                <div className="vwk-description-info-box">
                  <span className="vwk-description-info-label">
                    <i className="bi bi-arrows-vertical"></i>
                    Height
                  </span>

                  <strong>{selectedDescription.height || "-"} mm</strong>
                </div>

                <div className="vwk-description-info-box">
                  <span className="vwk-description-info-label">
                    <i className="bi bi-bounding-box"></i>
                    Area
                  </span>

                  <strong>{selectedDescription.area || "-"} mm</strong>
                </div>

                <div className="vwk-description-info-box">
                  <span className="vwk-description-info-label">
                    <i className="bi bi-palette"></i>
                    Color
                  </span>

                  <strong>{selectedDescription.color || "-"}</strong>
                </div>
              </div>

              {/* FULL DESCRIPTION */}
              <div className="vwk-full-description-box">
                <div className="vwk-full-description-title">
                  <i className="bi bi-file-text"></i>
                  Description
                </div>

                <p>
                  {selectedDescription.description ||
                    "No description available."}
                </p>
              </div>
            </div>

            {/* FOOTER */}
            <div className="vwk-pm-footer">
              <button
                className="vwk-pm-btn vwk-pm-btn-cancel"
                onClick={() => setShowDescriptionModal(false)}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
